
import React from 'react'
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ComposedChart, 
} from "recharts";
import FinancialCharts from './FinancialCharts';



const Report = ({ chartData }) => {

   // Default demo data (you can replace with API data later)
  const data = chartData || [
    { name: "Jan", sales: 4000, revenue: 2400 },
    { name: "Feb", sales: 3000, revenue: 1398 },
    { name: "Mar", sales: 2000, revenue: 9800 },
    { name: "Apr", sales: 2780, revenue: 3908 },
    { name: "May", sales: 1890, revenue: 4800 },
    { name: "Jun", sales: 2390, revenue: 3800 },
    { name: "Jul", sales: 3490, revenue: 4300 },
  ];

  const pieData = [
    { name: "Electronics", value: 400 },
    { name: "Fashion", value: 300 },
    { name: "Home", value: 300 },
    { name: "Toys", value: 200 },
  ];

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
  return (
    <div className = "h-screen w-full">
    <div className="p-6 space-y-8 mt-20">
      <h1 className="text-2xl font-bold text-center mb-4">📊 Sales Dashboard</h1>

    

        {/* Pie Chart */}
      <div className="w-full h-80 bg-white shadow-md rounded-xl p-4 flex justify-center items-center">
        <div className="w-80 h-80">
          <h2 className="text-lg font-semibold mb-2 ">Pie Chart - Category Distribution</h2>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={({ name }) => name}
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Bar Chart */}
   {/* Vertical Bar Chart */}
<div className="w-full h-[500px] bg-white shadow-md rounded-xl p-4">
  <h2 className="text-lg font-semibold mb-2">Bar Chart - Monthly Performance (Vertical)</h2>
  <ResponsiveContainer width="100%" height="100%">
    <BarChart
      layout="vertical"
      data={data}
      margin={{ top: 20, right: 30, left: 40, bottom: 20 }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      {/* Make Y-axis categories (months) */}
      <YAxis dataKey="name" type="category" />
      {/* Make X-axis numeric */}
      <XAxis type="number" />
      <Tooltip />
      <Legend />
      <Bar dataKey="sales" fill="#8884d8" barSize={20} radius={[5, 5, 0, 0]} />
      <Bar dataKey="revenue" fill="#82ca9d" barSize={20} radius={[5, 5, 0, 0]} />
    </BarChart>
  </ResponsiveContainer>
</div>
      {/* Line Chart */}
      <div className="w-full h-96 bg-white shadow-md rounded-xl p-4">
        <h2 className="text-lg font-semibold mb-2">Line Chart - Sales Over Time</h2>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="sales" stroke="#8884d8" />
            <Line type="monotone" dataKey="revenue" stroke="#82ca9d" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Mixed Chart (Bar + Line) */}
<div className="w-full h-80 bg-white shadow-md rounded-xl p-4">
  <h2 className="text-lg font-semibold mb-3">Mixed Chart - Sales vs Revenue</h2>
  <ResponsiveContainer width="100%" height="100%">
    <ComposedChart
      data={data}
      margin={{ top: 20, right: 20, bottom: 20, left: 0 }}
    >
      <CartesianGrid stroke="#f5f5f5" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Legend />

      {/* Bar: Sales */}
      <Bar dataKey="sales" barSize={30} fill="#8884d8" radius={[5, 5, 0, 0]} />

      {/* Line: Revenue */}
      <Line type="monotone" dataKey="revenue" stroke="#82ca9d" strokeWidth={3} />
    </ComposedChart>
  </ResponsiveContainer>
</div>

    </div>

    <div >
      {/* <div className='m-10' ></div> */}
      <FinancialCharts></FinancialCharts>


      
    </div>
    </div>
  )
}

export default Report